import { types } from './constants';

export const INITIAL_STATE = {
  castNotAllowed: false,
  content: null,
  isCasting: false,
  player: null,
  playerConfig: {
    castAppId: null,
    environment: null,
    jwtToken: null,
    playerID: null
  },
  returnCTA: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CAST_NOT_ALLOWED:
      return {
        ...state,
        castNotAllowed: true
      };
    case types.SET_IS_CASTING:
      return {
        ...state,
        isCasting: action.isCasting
      };
    case types.CLEAN_UP:
        return {
          INITIAL_STATE
        };
    case types.SET_INSTANCE:
          return{
            castNotAllowed: state.castNotAllowed,
            content: state.content,
            isCasting: state.isCasting,
            player: action.player,
            playerConfig: state.playerConfig,
            returnCTA: state.returnCTA
          };
    case types.STOP_NEXT_EPISODE:
          return{
            ...state,
            returnCTA: action.isStopped
          };
    default:
      return state;
  }
};

export default reducer;